import createAxiosInstance from "../LambdaApiAdministracion";
import { ENVIROMENT } from "../../utilities";

export async function GetFetchBanner() {
  const axiosInstance = await createAxiosInstance();
  const url = ENVIROMENT === "dev" ? `/admon/banner` : `/home/admon/banner`;
  const requestConfig = {
    method: "GET", // Cambia el método si es necesario
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  };

  // Realizar la solicitud Axios usando la instancia personalizada
  return axiosInstance(requestConfig);
}
